Vue.component('v-mark', require('@/js/components/view/mark/index.vue').default);
Vue.component('v-product-card', require('../../venue/js/view/collections/ProductCard.vue').default);
Vue.component('v-image-card', require('@/js/components/view/mark/card.vue').default);
Vue.component('v-collections-card', require('./view/collections/card.vue').default);
Vue.component('v-comments-item-box', require('@/js/components/view/comments/commentsItemBox.vue').default);
Vue.component('v-instagram', require('@/js/components/view/instagram/instagram.vue').default);
Vue.component('v-singlecommodity', require('@/js/components/view/singlecommodity/index.vue').default);
Vue.component('v-combination-recommendation', require('@/js/views/Home/Modules/CombinationRecommendation/index.vue').default);
Vue.component('v-module-comment', require('@/js/views/Home/Modules/Comment/index.vue').default);
Vue.component('v-module-video', require('@/js/views/Home/Modules/Video/index.vue').default);

setTimeout(()=>{
    window.startup()
    $('.vogue-swiper').each(function (index, element) {
        const item = $(element)
        const count = item.data('count')
        const interval = item.data('interval')
        let autoplay = !!item.data('autoplay')

        if (autoplay) {
            if (count <= 1) {
                autoplay = false
            }

            if (interval === 0) {
                autoplay = false
            }
        }

        const swiper = new window.AwesomeSwiper.Swiper(item.find('.swiper-vogue-index-banner'), {
            loop: count>1,
            effect: 'fade',
            fadeEffect:{
                crossFade: true,
            },
            autoHeight: true, //高度
            autoplay: autoplay ? {
                delay: interval * 1000
            } : false,
            navigation: {
                nextEl: '.vogue-button-next',
                prevEl: '.vogue-button-prev',
            },
            on: {
                slideChangeTransitionStart() {
                    const isFlash = item.find('.swiper-slide').eq(this.activeIndex).attr('isFlash')
                    if (isFlash === 'false') {
                        item.find('.swiper-slide-active img').addClass('innerBox')
                    }
                    const title = item.find('.swiper-slide').eq(this.activeIndex).attr('data-title')
                    const description = item.find('.swiper-slide').eq(this.activeIndex).attr('data-description')
                    const vogueBannerText =  item.siblings('#vogue-banner-text')
                    vogueBannerText.find('h5').text(title);
                    vogueBannerText.find('p').text(description);
                },
                slideChangeTransitionEnd() {
                    item.find('.swiper-slide-prev img').removeClass('innerBox')
                    item.find('.swiper-slide-next img').removeClass('innerBox')
                }
            },
        })

        item.find('.swiper-slide img').on("load", function () {
            swiper.update()
        })

        if (count <= 1) {
            item.find('.vogue-button-prev').hide()
            item.find('.vogue-button-next').hide()
        }
    })

    $('.vogue-video').each(function (index, element) {
        const item = $(element)
        const autoplay = item.data('videoAuto')
        const video_src = item.data('videoSrc')

        const obtn = item.find('.video')
        const oatn = item.find('.video-area')

        if (obtn.length) {
            if (autoplay) {
                obtn.hide()
                oatn.show()
            } else {
                obtn.show()
                oatn.hide()
            }
        } else {
            obtn.hide()
            oatn.show()
            item.find('iframe').src = video_src
        }

        obtn.click(function () {
            obtn.hide()
            item.find('iframe').src = video_src
            oatn.show()
        })
    })
}, 10);
